module.exports = __webpack_public_path__ + "assets/img/featured-3.33804fe4.jpg";